export const AUDIO_FILE = {
  fileID: "",
  fileURL: "",
  fileName: "",
};

export const STEP = {
  aboveContent: ``,
  belowContent: ``,
  itemType: "step",
  children: [],
  audio: { ...AUDIO_FILE },
};

export const BUTTON = {
  text: "Claim Now",
  link: "",
  type: "primary",
  checkIcon: false,
  closeIcon: false,
  itemType: "button",
  children: [],
};
